import "./App.css";
import "./Styles/Device.css";
import "./Styles/FAQContainer.css";
import "./Styles/Notifications.css";
import "./Styles/ProfileContainer.css";
import "./Styles/QualifyingRounds.css";
import "./Styles/InterviewContainer.css";
import "./Styles/InstructionContainer.css";
import "./Styles/VerifyContainer.css";
import "./Styles/InterviewChallengerContainer.css";
import "./Styles/SysAdminContainer.css";
import "./Styles/Admin_styles/HeaderBar.css";
import "./Styles/Admin_styles/AdminContentsWrapper.css";
import "./Styles/Admin_styles/Admin_InterviewContainer.css";
import "./Styles/Admin_styles/ReportSettings.css";
import './Components/Calendar/Calendar.css'
import 'react-toastify/dist/ReactToastify.css';
import "dayjs/locale/ru";
import dayjs from "dayjs";

import { BrowserRouter } from "react-router-dom";
import LayoutPage from "./Pages/LayoutPage";
import React, { Suspense } from "react";
import { HelmetProvider } from 'react-helmet-async';
import { Loading } from "./Components/Spinner/Loading";
import { UserProvider } from "./Providers/UserProvider";
import { MessageProvider } from "./Providers/MessageProvider";
import { RouteChangeLogger } from "./Components/RouteChangeLogger/RouteChangeLogger";
import './Providers/i18nProvider';
var isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)
dayjs.locale("ru");

function App() {
  
  return (
    <div className="App">
      <Suspense fallback={Loading}>
      <HelmetProvider>
        <BrowserRouter>
          <RouteChangeLogger />
          <UserProvider>
            <MessageProvider>
              <LayoutPage />
            </MessageProvider>
          </UserProvider>
        </BrowserRouter>
        </HelmetProvider>
      </Suspense>
    </div>
  );
}

export default App;
